import {useTheme} from "@mui/styles";
import React from "react";
import styled from "styled-components";

import HorizontalScroll from "react-scroll-horizontal";
import Footer from "../../components/Layout/Footer";
import Layout from "../../components/Layout/Layout";

import ModularAndReplaceable from "./WhyEvrbedSlide2";
import NeverBuyAnotherBed from "./WhyEvrbedSlide1";
import PersonalizedExperience from "./WhyEvrbedSlide3";
import SustainabilityMatters from "./WhyEvrbedSlide4";
import WhyEvrbedHeader from "./WhyEvrbedHeader";

const WhyEvrbed = () => {
  const theme = useTheme();
  return (
    <Layout
      backgroundColor={"#f8fbfd"}
      // width={"6000px"}
      height={"98vh"}
      styles={{ overflow: "hidden" }}
    >
      {/*  Header */}
      <WhyEvrbedHeader
        styles={{ marginLeft: "-4800px" }}
        showBuildMyBed={true}
        showCart={true}
        cartIconColor={theme.COLORS.BLUE.darkBlueGreen}
        logoColums="col-10"
      />
      {/*  Body */}

      <SlideContainer>
        <HorizontalScroll
          reverseScroll={true}
          style={{ width: "100vw", height: "88vh", paddingTop:"1vh" }}
        >
          <NeverBuyAnotherBed />
          <ModularAndReplaceable />
          <PersonalizedExperience />
          <SustainabilityMatters />
        </HorizontalScroll>
      </SlideContainer>

      {/*  Footer */}
      <Footer showMenuButton={true} styles={{ zIndex: 1100 }}></Footer>
    </Layout>
  );
};

const SlideContainer = styled.div`
  display: flex;
  width: 1920px;
  height: 82vh;
  //margin: auto;
  flex-direction: row;
  //flex-wrap: nowrap;
  align-items: center;
`;

export default WhyEvrbed;
